module.exports = "../dist/img/product-detail-4-19.c0a7.jpg";